import React from "react";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { CustomPage } from "@/types/custom-page";

interface PageItemProps {
  page: CustomPage;
}

export const PageItem: React.FC<PageItemProps> = ({ page }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-36 w-64 flex-col justify-between gap-3 rounded-xl border border-zinc-200 bg-zinc-100 p-4">
      <div className="flex items-start justify-between gap-2">
        <Badge
          variant="secondary"
          className="bg-zinc-800 px-2 py-0 text-[10px] text-white"
        >
          {page.enabled
            ? t("mobileSettings.dashboard.pageEnabled", "Enabled")
            : t("mobileSettings.dashboard.pageDisabled", "Disabled")}
        </Badge>
        <FileText className="size-4 text-zinc-500" />
      </div>

      <div className="flex flex-col gap-1">
        <span className="line-clamp-2 text-sm font-medium">{page.title}</span>
        <span className="line-clamp-2 text-xs text-zinc-500">
          {page.buttonTitle}
        </span>
      </div>
    </div>
  );
};
